import React from 'react';

import componentUtils from '../../lib/componentUtils';

import './SideDrawerHeader.less';

interface SideDrawerHeaderProps {
  header: string | undefined;
  handleClose?: React.MouseEventHandler<HTMLElement>;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const SideDrawerHeader = ({
  header,
  handleClose,
  children,
  style,
}: SideDrawerHeaderProps): JSX.Element => {
  const hasChildren = componentUtils.hasChildren(children);

  return (
    <div style={style} className="zola-ui side-drawer-header__container">
      <i className="zola-ui-icon-close" onClick={handleClose} />
      <div className="side-drawer-header">
        {header && <h3>{header}</h3>}
        {hasChildren && children}
      </div>
    </div>
  );
};

export default SideDrawerHeader;
